"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateExampleList = exports.generateComplexList = exports.generateFullListSchema = exports.generateListSchema = exports.generateListData = exports.generateAttributeData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const randomEnumOption = (enumObject) => {
    let optionNb = 0;
    const optArr = [];
    for (const opt in enumObject) {
        optionNb++;
        optArr.push(enumObject[opt]);
    }
    const rdNb = en_1.faker.number.int({ min: 0, max: optionNb - 1 });
    return optArr[rdNb];
};
const generateAttributeData = (attrType) => {
    const att = {
        column_tag: (0, tools_1.IDSource)(),
        column_name: en_1.faker.word.words(2),
        type: attrType,
        required: en_1.faker.datatype.boolean(),
        is_hidden: en_1.faker.datatype.boolean(),
    };
    switch (attrType) {
        case types_1.CUSTOM_FIELD_TYPE.TEXT: {
            if (en_1.faker.datatype.boolean()) {
                att.validation = en_1.faker.lorem.word();
                att.validation_text = en_1.faker.word.words(5);
            }
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE:
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
            att.options = [
                { key: "opt1", value: "option 1" },
                { key: "opt2", value: "option 3" },
            ];
        }
    }
    return att;
};
exports.generateAttributeData = generateAttributeData;
const generateListData = (list = {}) => {
    const result = Object.assign(Object.assign({}, list), { id: list.id || (0, tools_1.IDSource)(), name: list.name || en_1.faker.word.words(2), description: list.description || en_1.faker.word.words(5), client_id: list.client_id || "_", scope: list.scope || randomEnumOption(types_1.LIST_SCOPE), can_update_items_ownership: list.can_update_items_ownership || en_1.faker.datatype.boolean(), schema: list.schema || (0, exports.generateListSchema)(), created_at: list.created_at || new Date(), updated_at: list.updated_at || new Date(), active: list.hasOwnProperty("active") ? !!list.active : true, version: 0, show_ids: list.hasOwnProperty("show_ids") ? !!list.show_ids : false });
    return result;
};
exports.generateListData = generateListData;
const generateListSchema = () => {
    const typeOfOptions = Object.values(types_1.CUSTOM_FIELD_TYPE);
    const schema = [];
    const numberOfAttr = en_1.faker.number.int({ min: 1, max: 5 });
    for (let i = 0; i < numberOfAttr; i++) {
        const randomNb = en_1.faker.number.int({
            min: 0,
            max: typeOfOptions.length - 1,
        });
        const randomType = typeOfOptions[randomNb];
        const attribute = {
            column_tag: en_1.faker.string.alphanumeric(10),
            column_name: en_1.faker.word.words(2),
            type: randomType,
            required: en_1.faker.datatype.boolean(),
        };
        if (randomType === types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE ||
            randomType === types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE) {
            attribute["options"] = [
                { key: "opt1", value: "option 1" },
                { key: "opt2", value: "option 2" },
            ];
        }
        if (randomType === types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST) {
            attribute["matrix"] = {
                typed_questions: [
                    {
                        column_tag: en_1.faker.string.alphanumeric(10),
                        column_name: en_1.faker.word.words(2),
                        type: types_1.CUSTOM_FIELD_TYPE.TEXT,
                        required: en_1.faker.datatype.boolean(),
                    },
                ],
            };
        }
        schema.push(attribute);
    }
    return schema;
};
exports.generateListSchema = generateListSchema;
const generateFullListSchema = () => {
    const schema = [];
    const allTypes = Object.values(types_1.CUSTOM_FIELD_TYPE);
    for (const type of allTypes) {
        const l = {
            column_tag: "a" + en_1.faker.string.alphanumeric(10),
            column_name: en_1.faker.word.words(2),
            type: type,
            required: en_1.faker.datatype.boolean(),
            is_hidden: en_1.faker.datatype.boolean(),
        };
        if (type === types_1.CUSTOM_FIELD_TYPE.TEXT) {
            if (en_1.faker.datatype.boolean()) {
                l.validation = en_1.faker.lorem.word();
                l.validation_text = en_1.faker.word.words(5);
            }
        }
        if (type === types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE ||
            type === types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE) {
            l.options = [
                { key: "opt1", value: "option 1" },
                { key: "opt2", value: "option 3" },
            ];
        }
        if (type === types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST) {
            l.matrix = {
                typed_questions: [
                    {
                        column_tag: en_1.faker.string.alphanumeric(10),
                        column_name: en_1.faker.word.words(2),
                        type: types_1.CUSTOM_FIELD_TYPE.TEXT,
                        required: en_1.faker.datatype.boolean(),
                    },
                ],
            };
        }
        schema.push(l);
    }
    return schema;
};
exports.generateFullListSchema = generateFullListSchema;
const generateComplexList = (clientId, listLinkedId) => ({
    id: (0, tools_1.IDSource)(),
    description: ".",
    active: true,
    client_id: clientId,
    created_at: new Date(),
    schema: [
        {
            column_name: "Customer name",
            column_tag: "name",
            required: true,
            type: types_1.CUSTOM_FIELD_TYPE.TEXT,
        },
        {
            column_name: "Customer age",
            column_tag: "age",
            required: false,
            type: types_1.CUSTOM_FIELD_TYPE.INTEGER,
        },
        {
            column_name: "Birthday",
            column_tag: "birthday",
            required: false,
            type: types_1.CUSTOM_FIELD_TYPE.DATE_PICKER,
        },
        {
            column_name: "Lunch time",
            column_tag: "lunchtime",
            required: false,
            type: types_1.CUSTOM_FIELD_TYPE.TIME_PICKER,
        },
        {
            column_name: "barcode",
            column_tag: "barcode",
            required: false,
            type: types_1.CUSTOM_FIELD_TYPE.BARCODE_SCANNER,
        },
        {
            column_name: "boolean",
            column_tag: "boolean",
            required: false,
            type: types_1.CUSTOM_FIELD_TYPE.BOOLEAN,
        },
        {
            column_name: "gps",
            column_tag: "gps",
            required: false,
            type: types_1.CUSTOM_FIELD_TYPE.GPS,
        },
        {
            column_name: "multiple choice",
            column_tag: "multiplechoice",
            required: false,
            options: [
                {
                    key: "opt1",
                    value: "option 1",
                },
                {
                    key: "opt2",
                    value: "option 2",
                },
            ],
            type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE,
        },
        {
            column_name: "single choice",
            column_tag: "singlechoice",
            required: false,
            options: [
                {
                    key: "opt1",
                    value: "option 1",
                },
                {
                    key: "opt2",
                    value: "option 2",
                },
            ],
            type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE,
        },
        {
            column_name: "single choice on list",
            column_tag: "singlechoiceonlist",
            required: false,
            list_id: listLinkedId,
            type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST,
        },
        {
            column_name: "multiple choice on list",
            column_tag: "multiplechoiceonlist",
            required: false,
            list_id: listLinkedId,
            type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST,
        },
    ],
    show_ids: false,
    updated_at: new Date(),
    important: ["name"],
    name: "Customer",
    scope: types_1.LIST_SCOPE.GLOBAL,
});
exports.generateComplexList = generateComplexList;
const generateExampleList = (listId, clientId) => ({
    id: listId,
    description: ".",
    active: true,
    client_id: clientId,
    name: "List example",
    scope: types_1.LIST_SCOPE.GLOBAL,
    schema: [
        {
            column_tag: "name",
            column_name: "Name",
            required: true,
            type: types_1.CUSTOM_FIELD_TYPE.TEXT,
        },
        {
            column_tag: "age",
            column_name: "Age",
            required: true,
            type: types_1.CUSTOM_FIELD_TYPE.INTEGER,
        },
        {
            column_tag: "country",
            column_name: "Country",
            required: true,
            type: types_1.CUSTOM_FIELD_TYPE.TEXT,
        },
    ],
    created_at: new Date(),
    updated_at: new Date(),
    show_ids: false,
});
exports.generateExampleList = generateExampleList;
